<template>
  <section>
    <custom-button data-toggle="modal" data-target="#modalAdd">
      Add New Product
    </custom-button>
    <div class="modal fade" id="modalAdd" role="dialog">
      <div class="modal-dialog modal-dialog-centered">
        <!-- Modal content-->
        <div class="modal-content text-main-color">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Add New Product</h4>
            </div>
            <button @click="resetField" type="button" class="close" data-dismiss="modal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <label class="fw-500 mb-4">Please choose what you want to add</label
            ><br />
            <div>
              <button
                type="button"
                @click="handleClickOption('unit')"
                :class="[
                  'option-btn',
                  productTypeAdd === 'unit' ? 'option-btn-active' : '',
                ]"
              >
                <div>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22.919 16.515C22.65 15.731 21.799 15.315 21.015 15.581C20.988 15.59 18.278 16.5 14 16.5C10.89 16.5 7.772 16.003 6.264 15.723C5.984 14.286 5.5 11.394 5.5 8.5C5.5 6.477 5.677 4.339 5.974 2.78C6.057 2.341 5.941 1.887 5.656 1.543C5.371 1.199 4.948 1 4.501 1H2.5C1.672 1 1 1.671 1 2.5C1 3.329 1.672 4 2.5 4H2.757C2.591 5.399 2.5 6.963 2.5 8.5C2.5 12.904 3.498 17.167 3.54 17.346C3.673 17.905 4.112 18.339 4.672 18.464C4.731 18.477 5.217 18.585 6 18.726V20C6 21.654 7.346 23 9 23C10.654 23 12 21.654 12 20V19.443C12.655 19.479 13.326 19.5 14 19.5C14.705 19.5 15.373 19.477 16 19.439V20C16 21.654 17.346 23 19 23C20.654 23 22 21.654 22 20V18.414C22.775 18.14 23.186 17.293 22.919 16.515Z"
                      fill="#2E3646"
                    />
                    <path
                      d="M14 7C14.308 7 14.562 6.904 14.736 6.722C14.905 6.545 14.999 6.289 14.999 6V3.02C14.676 3.007 14.342 3 13.999 3C13.656 3 13.321 3.007 12.999 3.019V6C12.999 6.551 13.448 7 13.999 7H14Z"
                      fill="#2E3646"
                    />
                    <path
                      d="M8.44598 14.3951C8.54398 14.4201 10.886 15.0001 14 15.0001C17.14 15.0001 19.459 14.4181 19.557 14.3941C19.885 14.3101 20.149 14.0661 20.257 13.7451C20.287 13.6551 21 11.5181 21 9.00012C21 6.48212 20.287 4.34612 20.257 4.25612C20.149 3.93412 19.884 3.68912 19.554 3.60612C19.492 3.59012 18.512 3.34712 17 3.17412V6.00112C17 6.80812 16.709 7.55612 16.181 8.10712C15.628 8.68312 14.855 9.00112 14.001 9.00112C12.347 9.00112 11.001 7.65412 11.001 6.00112V3.17212C9.48198 3.34612 8.50698 3.59012 8.44398 3.60612C8.11598 3.69012 7.85198 3.93412 7.74398 4.25512C7.71398 4.34512 7.00098 6.48212 7.00098 9.00012C7.00098 11.5181 7.71398 13.6541 7.74398 13.7441C7.85198 14.0661 8.11698 14.3111 8.44698 14.3941L8.44598 14.3951Z"
                      fill="#2E3646"
                    />
                  </svg>
                </div>
                <p>Unit Product</p>
              </button>
              <button
                @click="handleClickOption('bundling')"
                type="button"
                :class="[
                  'option-btn',
                  productTypeAdd === 'bundling' ? 'option-btn-active' : '',
                ]"
              >
                <div>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M22 19.201V20C22 21.654 20.654 23 19 23C17.346 23 16 21.654 16 20V19.954C15.371 19.982 14.706 20 14 20C13.316 20 12.648 19.976 12 19.939V20C12 21.654 10.654 23 9 23C7.346 23 6 21.654 6 20V19.148C5.49 19.042 5.18 18.966 5.136 18.955C4.599 18.821 4.179 18.401 4.045 17.864C4.002 17.694 3 13.637 3 9.50005C3 7.24305 3.153 5.30405 3.293 4.00005H2.5C1.672 4.00005 1 3.32905 1 2.50005C1 1.67105 1.672 1.00005 2.5 1.00005H5C5.44 1.00005 5.859 1.19405 6.144 1.53005C6.429 1.86605 6.552 2.31105 6.48 2.74605C6.475 2.77505 6.001 5.68505 6.001 9.50005C6.001 12.177 6.478 14.881 6.757 16.239C8.144 16.519 10.971 17 14.001 17C18.248 17 21.131 16.341 21.159 16.334C21.959 16.145 22.771 16.646 22.961 17.453C23.137 18.204 22.711 18.948 22 19.201ZM9.092 14.744C9.189 14.754 11.487 15 15 15C18.513 15 20.812 14.754 20.908 14.744C21.35 14.696 21.708 14.361 21.785 13.923C21.794 13.873 22 12.685 22 11.5C22 10.315 21.794 9.12705 21.785 9.07705C21.708 8.63905 21.35 8.30405 20.908 8.25605C20.811 8.24605 18.513 8.00005 15 8.00005C11.487 8.00005 9.188 8.24605 9.092 8.25605C8.65 8.30405 8.292 8.63905 8.215 9.07705C8.206 9.12705 8 10.315 8 11.5C8 12.685 8.206 13.873 8.215 13.923C8.292 14.361 8.65 14.696 9.092 14.744ZM16.985 6.77605C17.027 6.78505 18.013 7.00005 19 7.00005C19.987 7.00005 20.973 6.78605 21.015 6.77605C21.396 6.69305 21.693 6.39505 21.777 6.01405C21.786 5.97205 22.001 4.98505 22.001 3.99905C22.001 3.01305 21.786 2.02605 21.777 1.98405C21.693 1.60305 21.396 1.30605 21.015 1.22205C20.973 1.21305 19.987 0.998047 19 0.998047C18.013 0.998047 17.027 1.21205 16.985 1.22205C16.604 1.30505 16.307 1.60305 16.223 1.98405C16.214 2.02605 15.999 3.01305 15.999 3.99905C15.999 4.98505 16.214 5.97205 16.223 6.01405C16.307 6.39505 16.604 6.69205 16.985 6.77605ZM9.077 6.78505C9.127 6.79405 10.315 7.00005 11.5 7.00005C12.685 7.00005 13.873 6.79305 13.923 6.78505C14.304 6.71805 14.612 6.43805 14.715 6.06505C14.726 6.02305 15 5.01205 15 4.00105C15 2.99005 14.726 1.97905 14.715 1.93705C14.612 1.56405 14.304 1.28405 13.923 1.21705C13.873 1.20805 12.685 1.00205 11.5 1.00205C10.315 1.00205 9.127 1.20905 9.077 1.21705C8.696 1.28405 8.388 1.56405 8.285 1.93705C8.274 1.97905 8 2.99005 8 4.00105C8 5.01205 8.274 6.02305 8.285 6.06505C8.388 6.43805 8.696 6.71805 9.077 6.78505Z"
                      fill="#2E3646"
                    />
                  </svg>
                </div>
                <p>Bundling Product</p>
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <div class="d-flex justify-content-end" style="gap: 12px">
              <custom-button
                color="ghost"
                variant="outlined"
                data-dismiss="modal"
                @click="resetField"
              >
                Cancel
              </custom-button>
              <custom-button :disabled="false" @click="nextAdd">
                Next
              </custom-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { CustomButton } from "../../Button";

export default {
  name: "ModalOptionAddProduct",
  components: { CustomButton },
  props: {},
  data() {
    return {
      productTypeAdd: "",
      loadingButtonNext: false,
    };
  },
  methods: {
    handleClickOption(type) {
      this.productTypeAdd = type;
    },
    resetField() {
      this.productTypeAdd = "";
    },
    nextAdd() {
      this.$router.push({
        path: this.productTypeAdd === "unit" ? "/catalog/create" : "/catalog/form",
        query: {
          f: "Add",
          unit: this.productTypeAdd === "unit" ? 1 : 0,
          catalogId: 0,
        },
      });
    },
  },
};
</script>

<style scoped>
.option-btn {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  border: 1px solid #cfd3d9;
  border-radius: 8px;
  padding: 1.25rem;
  margin-bottom: 0.5rem;
  background: #f8f9fa;
  outline: none;
}

.option-btn p {
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}

.option-btn-active {
  color: #1d54b0;
  border: 1px solid #3098f7;
  background: #e6f3fe;
}

.option-btn-active svg path {
  fill: #1d54b0;
}
</style>


// WEBPACK FOOTER //
// src/components/Catalog/Components/ModalOptionAddProduct.vue